import { createSlice } from "@reduxjs/toolkit";
import { GetAppsUrlAction, UpdateAppsUrlAction } from "store/middlewares/dataManagement/getTheApps";


export const appUrlSlice = createSlice({
  name: "appUrl",
  initialState: {
    appUrlLoading: false,
    appUrl: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAppsUrlAction.pending, (state) => {
        state.appUrlLoading = state.appUrl?.data.length > 0 ? false : true;
        state.appUrl = state.appUrl?.data.length > 0 ? state.appUrl : null;
      })

      .addCase(GetAppsUrlAction.fulfilled, (state, action) => {
        state.appUrlLoading = false;   
        state.appUrl = action.payload.response;
      })

      .addCase(GetAppsUrlAction.rejected, (state) => {
        state.appUrlLoading = false;
        state.appUrl = null;
      })

     
      // Update appUrl
      .addCase(UpdateAppsUrlAction.fulfilled, (state, action) => {
        state.appUrlLoading = false;
       state.appUrl = state.appUrl.map((item) =>
         item.id === action.payload.response.id
           ? action.payload.response
           : item,
       );
      })

  },
});
export default appUrlSlice.reducer;
